'use strict';
var getBuiltIn = require('../internals/get-built-in');
var setToStringTag = require('../internals/set-to-string-tag');

var DOM_EXCEPTION = 'DOMException';

// `DOMException.prototype[@@toStringTag]` property
setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/web.dom-exception.to-string-tag.js
// module id = 704
// module chunks = 0